export enum MenuMediaPublicationStatus {
    ONLINE = 'ONLINE',
    OFFLINE = 'OFFLINE',
}
